/**
 * Of een scrollvak (bijna) onderaan staat.
 *
 * Nodig omdat het Decca-venster pas aan het eind van een beurt meescrolde, zodat
 * de laadmelding en het binnenkomende antwoord onder de vouw vielen (testronde
 * 2026-10-27, B8). Meescrollen mag alleen als de lezer onderaan stond: wie
 * terugleest, wordt niet weggetrokken.
 *
 * @param {{scrollTop: number, clientHeight: number, scrollHeight: number}|null} el
 * @param {number} [margin=80] - Pixels speling
 * @returns {boolean}
 */
const isNearBottom = (el, margin = 80) => {
    if (!el) return true
    return el.scrollHeight - el.scrollTop - el.clientHeight <= margin
}

export default isNearBottom
